<template>
  <div>
    <div :class="view_class_view.div_container_section.container">
      <!-- Title -->
      <label
        :class="view_class_view.div_container_section.label"
        for="select_scholarship"
      >
        Escolaridad:</label
      >

      <!-- Form -->
      <div :class="view_class_view.div_container_section.form">
        <div>
          <select
            id="select_scholarship"
            v-model.trim="schoolingModelValidation.educationLevel.$model"
            @blur="schoolingModelValidation.educationLevel.$validate"
            @change="on_change_scholarship()"
            v-bind:class="{
              [view_class_view.classInputs.default +
              view_class_view.classInputs.no_valid]:
                schoolingModelValidation.educationLevel.$error,
              [view_class_view.classInputs.default +
              view_class_view.classInputs.valid]:
                !schoolingModelValidation.educationLevel.$invalid,
              [view_class_view.classInputs.default]:
                schoolingModelValidation.educationLevel.$invalid &&
                !schoolingModelValidation.educationLevel.$error,
            }"
          >
            <option value="seleccionar" selected hidden>
              Seleccione un grado escolar
            </option>
            <option
              :value="item.value"
              v-for="(item, i) in educationLevelsList"
              :key="i"
            >
              {{ item.text }}
            </option>
          </select>

          <div
            v-for="error of schoolingModelValidation.educationLevel.$errors"
            :key="error.$message"
          >
            <div class="errors">{{ error.$message }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "@vue/reactivity";
import useVuelidate from "@vuelidate/core";

export default {
  name: "SchoolingComponent",

  props: {
    validations: {},
    view_class_view: {},
  },

  setup(props, { emit }) {

    const educationLevelsList = ref([
      { value: "primaria", text: "Primaria" },
      { value: "secundaria", text: "Secundaria" },
      { value: "preparatoria", text: "Preparatoria" },
      { value: "técnica comercial", text: "Técnica comercial" },
      { value: "licenciatura", text: "Licenciatura" },
      { value: "posgrado", text: "Posgrado" },
    ]);

    const educationLevel = ref("seleccionar");

    let schoolingModel = ref({ educationLevel: "" });

    const schoolingModelValidation = useVuelidate(
      props.validations,
      schoolingModel.value
    );

    const execute_validation = () => {
            schoolingModelValidation.value.$validate();

            if(schoolingModelValidation.value.$error){
                return false;
            }

            return schoolingModel.value;
    }
    
    const on_change_scholarship = () => {
      emit("Schooling", schoolingModel.value);
    };

    return {
      v$: useVuelidate(),
      educationLevelsList,
      educationLevel,
      schoolingModelValidation,
      on_change_scholarship,
      schoolingModel,
      execute_validation
    };
  },

  watch: {
    educationLevel: {
      handler(data) {
        this.$emit("scholarship-information-data", data);
      },
      deep: true,
    },
  },
};
</script>
